import { render, staticRenderFns } from "./Article.vue?vue&type=template&id=2a6b11a2&"
import script from "./Article.vue?vue&type=script&lang=js&"
export * from "./Article.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src307848888/src/github.com/trainn-tech/trainn-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a6b11a2')) {
      api.createRecord('2a6b11a2', component.options)
    } else {
      api.reload('2a6b11a2', component.options)
    }
    module.hot.accept("./Article.vue?vue&type=template&id=2a6b11a2&", function () {
      api.rerender('2a6b11a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/icons/Article.vue"
export default component.exports